import useStores from '@stores/useStores';
import { LockedResource, LockedResourceType } from '@api';
import { constructLockedResourceMessage, getLockedResource } from './useActionGuard/utils';

export const useLockedResource = (
  resourceType: LockedResourceType,
  resourceId: string | string[],
  predicate?: (lock: LockedResource) => boolean,
  fallbackPredicate?: (lock: LockedResource) => boolean,
): { isLocked: boolean; reason: string | undefined } => {
  const { organizationStore, userStore } = useStores();

  const lock = getLockedResource(organizationStore.lockedResources, {
    activeWorkspaceId: userStore.selectedWorkspaceId,
    resourceType,
    resourceId,
    predicate,
    fallbackPredicate,
  });

  return {
    isLocked: !!lock,
    reason: lock ? constructLockedResourceMessage(lock.reason, lock.resourceType) : undefined,
  };
};
